<script setup>
import { i18n } from 'boot/i18n';

defineOptions({ name: 'ReconciliationSettingsForm' });

const props = defineProps({
  settings: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update:settings']);

function normalizeTolerance(value) {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue) || numericValue < 0) {
    return 0;
  }

  return Math.floor(numericValue);
}

function preventNegativeInput(event) {
  if (event.key === '-' || event.key === 'e') {
    event.preventDefault();
  }
}

/**
  * Emits an update to the start time tolerance in the settings.
 * @param {number} newStartTimeTolerance - The new start time tolerance.
 */
function emitStartTimeTolerance(newStartTimeTolerance) {
  emit('update:settings', {
    ...props.settings,
    startTimeToleranceMinutes: normalizeTolerance(newStartTimeTolerance),
  });
} // emitStartTimeTolerance()

/**
 * Emits an update to the end time tolerance in the settings.
 * @param {number} newEndTimeTolerance - The new end time tolerance.
 */
function emitEndTimeTolerance(newEndTimeTolerance) {
  emit('update:settings', {
    ...props.settings,
    endTimeToleranceMinutes: normalizeTolerance(newEndTimeTolerance),
  });
} // emitEndTimeTolerance()

</script>
<template>
  <div class="row col-12 q-col-gutter-md">
    <p class="text-subtitle2 col-12">
      {{ i18n.t('activityReconciliation.settingsForm.title') }}
    </p>
    <q-input
      :model-value="props.settings.startTimeToleranceMinutes"
      :label="i18n.t('activityReconciliation.settingsForm.startTimeTolerance')"
      type="number"
      min="0"
      step="1"
      outlined
      class="col-6"
      @keydown="preventNegativeInput"
      @update:model-value="emitStartTimeTolerance"
    />
    <q-input
      :model-value="props.settings.endTimeToleranceMinutes"
      :label="i18n.t('activityReconciliation.settingsForm.endTimeTolerance')"
      type="number"
      min="0"
      step="1"
      outlined
      class="col-6"
      @keydown="preventNegativeInput"
      @update:model-value="emitEndTimeTolerance"
    />
  </div>
</template>
